import * as React from 'react';
import { Panel, PanelType, IPanelProps } from '@fluentui/react/lib/Panel';
import {bindActionCreators} from 'redux';
import { getPanelOpened, getPanelContent, getPanelTitle, getLoading } from '../../redux/reducers/ui';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { DocumentActions as UiDocumentActions, CommandActions as UiCommandActions } from '../../redux/actions/ui';
import { getClassNames } from './index.classNames';
import RingerContent from '../../components/ringer/index';
import ChangelogContent from '../../components/changelog/index';
import DownloadMenu from '../downloadMenu/index';
//import AccountContent from '../login/user';
import { IRenderFunction } from '@fluentui/react/lib/Utilities';
import { Text } from '@fluentui/react/lib/Text';
import { DefaultButton} from '@fluentui/react';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';

export interface PanelProps { 
    panelOpened: boolean, 
    panelContent?: string, 
    panelTitle?: string, 
    loading: boolean,
    setPanelStatus: typeof UiDocumentActions.setPanelStatus, 
    sendFeedback: typeof UiCommandActions.sendFeedback 
}

const styles = getClassNames();

class RightPanel extends React.Component<PanelProps> {
    constructor(props: PanelProps) {
        super(props);
    }

    hidePanel = () => {
        const {setPanelStatus,} = this.props;
        setPanelStatus({open: false, title: undefined, content: undefined});
    };

    onRenderNavigationContent: IRenderFunction<IPanelProps> = ((props, defaultRender) => {
        let title = this.props.panelTitle;  
        return (      
        <>   
            <Text className={styles.headerLabel} variant='xLarge' nowrap>{title}</Text>
            {// This custom navigation still renders the close button (defaultRender).
            // If you don't use defaultRender, be sure to provide some other way to close the panel.
            defaultRender!(props)}
        </>
        )
      });

    //   onRenderFooterContent = () => {
    //     const { panelContent, sendFeedback, loading } = this.props;
    //     return (
    //         <>
    //             {panelContent === 'downloadMenu' &&
    //                 <div style={{display: 'flex', justifyContent: 'flex-end' }}>               
    //                     { !loading && <DefaultButton styles={{root: {width: 54}}} text="Submit" onClick={() => sendFeedback()}/>}
    //                     { loading  && <DefaultButton styles={{root: {width: 54}}}><Spinner size={SpinnerSize.small}></Spinner></DefaultButton>}
    //                 </div>             
    //             }
    //         </>
    //     );
    //   };

    render() {
        const {panelOpened, panelContent} = this.props;
        return (
            <Panel
                className={styles.panel}
                styles={{navigation: styles.header, scrollableContent: styles.scrollableContent, content:{ paddingLeft: 0, paddingRight: 0}}}
                isOpen={panelOpened}
                isBlocking={false}
                type={PanelType.smallFixedFar}
                onDismiss={this.hidePanel}
                headerText=""
                closeButtonAriaLabel="Close"
                onRenderNavigationContent={this.onRenderNavigationContent}
                isHiddenOnDismiss={true}
                //onRenderFooterContent={panelContent === 'downloadMenu' ? this.onRenderFooterContent : undefined}
            >  
                {panelContent === 'ringer' &&
                    <RingerContent/>
                }
                {panelContent === 'changelog' &&
                    <ChangelogContent/>
                }   
                {panelContent === 'downloadMenu' &&
                    <DownloadMenu/>
                }     
                {/* {panelContent === 'account' &&
                    <AccountContent/>
                }              */}
            </Panel>
        );
    }
}


const mapStateToProps = createStructuredSelector({
    panelOpened: getPanelOpened,
    panelContent: getPanelContent,
    panelTitle: getPanelTitle,
    loading: getLoading
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({ setPanelStatus: UiDocumentActions.setPanelStatus, sendFeedback: UiCommandActions.sendFeedback}, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)((RightPanel));
